<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="true" :hideFilter="$route.query[pk + 'filter'] === undefined"
      :hideOverlayRoute="$route.params.contractId == undefined" @Added="handleadded" @Changed="handlechanged">

      <template v-slot:filter>
        <FilterPane :title="'ffff'" :pk="pk">
          <template v-slot:filters-content>
            <DefaultLifeCycleFilterGroup :pk="pk"></DefaultLifeCycleFilterGroup>
          </template>
        </FilterPane>
      </template>

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="getContractListFromFilter" :optional-filters="filters" :locked-filters="lockedFilters"
          :paginationEnabled="true" :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="50" ref="ListPane"
          :pk="pk">

          <template v-slot:list-item="{ item }">
            <v-list-item @click="openItem(item)">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.Id }} {{ item.Name }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="item.LastOrderDate" class="d-flex flex-row">
                <v-icon size="20" class="mr-2">mdi-clipboard-text-clock</v-icon>
                {{ i18nFormatDate(item.LastOrderDate) }}
              </v-list-item-action>
            </v-list-item>
          </template>

        </ListPane>
      </template>

    </Layout>

    <NewContractDialog :externaltrigger="newContractTrigger" :externalCloseTrigger="newContractCloseTrigger"
      :contractTypeId="$route.params.contractTypeId" @Added="onContractCreated"
      @RequestClose="newContractCloseTrigger++">
    </NewContractDialog>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import FilterPane from "@/components/Sections/Panes/FilterPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
//import ListItem from "@/views/admin/AssetTypeListItem.vue";
import DefaultLifeCycleFilterGroup from "@/components/DefaultLifeCycleFilterGroup.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";
import NewContractDialog from "@/components/Dialogs/NewContractDialog.vue";

export default {
  name: "AdminContractList",
  props: {},
  components: {
    ListPane,
    FilterPane,
    Layout,
    //ListItem,
    DefaultLifeCycleFilterGroup,
    NewContractDialog,
  },
  mixins: [clientAPI, FilterQueryMixin, ContractMixin],

  data() {
    return {
      pk: "ACOL-",
      editItem: null,
      dialogtrigger: 1,
      newContractTrigger: 1,
      newContractCloseTrigger: 1,
    };
  },

  methods: {
    handleadded: (item) => this.$refs.ListPane.handleadded(item),
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    openItem(item) {
      if (!this.showNewContractViews) {
        this.$router.push({ name: 'OldContractView', params: { contractId: item.Id } });
      }
      else {
        this.$router.push({
          name: this.getViewRouteFromContractType(item.ContractTypeId), //from mixin
          params: {
            contractId: item.Id,
            contractTypeId: item.ContractTypeId,
          },
        });
      }
    },

    openNewContractDialog() { this.newContractTrigger++; },

    onContractCreated(contract) {
      // Update list and navigate to created contract
      if (contract) {
        this.$refs.ListPane.handleadded(contract);
        this.openItem(contract);
      }
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
          ActiveState: this.getQueryParam("filter-active", 0),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    lockedFilters() {
      return {
        ContractTypeIdList: [this.$route.params.contractTypeId],
      };
    },

    externalNewTrigger() {
      return this.$store.state.triggerevents.newTrigger;
    },

    showNewContractViews() {
      return this.$store.state.GlobalSettings.ShowNewContractViews;
    },
  },

  watch: {
    externalNewTrigger() {
      if (this.$route.name == 'Contracts') {
        this.openNewContractDialog();
      }
    }
  },
};
</script>


<style lang='scss' scoped></style>